import styled, { css } from 'styled-components';
import {
  NATIVE_GREY,
  NEUTRAL_100,
  NEUTRAL_200,
  NEUTRAL_500,
  POSITIVE_500,
  PRIMARY_100,
  PRIMARY_500,
  TERTIARY_500,
  WHITE,
} from '../../styles/colors';
import {
  FONT_WEIGHT_BOLD,
  FONT_WEIGHT_LIGHT,
  FONT_WEIGHT_NORMAL,
  FONT_WEIGHT_REGULAR,
} from '../../styles/typography';
import { isAmazonHost } from '../../utils';

export const Cards = styled.div`
  &&& {
    .card-column {
      min-width: 295px;
      ${() =>
        !isAmazonHost() &&
        css`
          max-width: 385px;
          min-width: 350px;
          @media only screen and (max-width: 430px) {
            min-width: 100%;
          }
        `};

      :only-child {
        @media (orientation: landscape) {
          button {
            width: auto;
          }
        }
      }
    }

    ${() =>
      isAmazonHost() &&
      css`
        & > div {
          & h4 {
            font-size: 18px !important;
            line-height: 22px !important;
            margin: 0;
            ${FONT_WEIGHT_BOLD};
          }

          & p {
            font-size: 15px !important;
            line-height: 21px !important;
            ${FONT_WEIGHT_NORMAL};
          }
        }
      `}
  }
`;

export const StyledCard = styled.div`
  &&& {
    border-radius: 8px;
    border: 1px solid ${TERTIARY_500};
    font-size: 14px;
    ${FONT_WEIGHT_LIGHT};
    background-color: ${WHITE};
    height: 100%;

    p {
      margin-bottom: 8px;
      margin-top: 0px;
    }

    button {
      width: 100%;
      line-height: 24px;
      padding-left: 16px;
      padding-right: 16px;
    }
  }
`;

export const Content = styled.div`
  &&& {
    padding: 4px 24px 24px 24px;
    display: flex;
    flex-direction: column;

    > .text {
      padding: 16px 0;
    }

    p {
      margin: 0;
      padding: 0;
    }

    ul {
      list-style: 'none';
      margin: 0;
      padding: 8px 0 0 0 !important;

      > li {
        display: flex;
        align-items: center;
        padding: 0;
        height: 40px;
        line-height: normal;
        ${FONT_WEIGHT_NORMAL};

        > img {
          margin-right: 4px;
          width: 24px;
        }
      }
    }
  }
`;

export const Header = styled.div<{ recommended: boolean }>`
  &&& {
    max-width: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    border-radius: 8px 8px 0 0;
    height: 135px;
    justify-content: space-between;
    ${() =>
      !isAmazonHost() &&
      css`
        height: 190px;
        gap: 8px;
        justify-content: normal;

        @media only screen and (max-width: 430px) {
          height: auto;
          gap: 4px;
        }
      `}

    .card-column:only-child & {
      height: auto;
    }

    ${() =>
      isAmazonHost() &&
      css`
        border-bottom: 1px solid ${TERTIARY_500};
      `};
    ${(props) => {
      let color = isAmazonHost() ? WHITE : NATIVE_GREY;
      if (props.recommended) {
        color = PRIMARY_500;
        if (isAmazonHost()) {
          color = PRIMARY_100;
        }
      }
      return css`
        background-color: ${color};
      `;
    }};
    color: ${() => (isAmazonHost() ? NEUTRAL_500 : PRIMARY_100)};
    padding: 24px;
    ${() =>
      isAmazonHost() &&
      css`
        padding: 16px 24px;
      `};

    h4 {
      font-size: 28px;
      line-height: 42px;
      margin: 0;
      padding: 0;
    }

    p {
      font-size: 20px;
      line-height: 30px;
      ${FONT_WEIGHT_LIGHT};
      margin: 0;
      padding: 0;
    }

    > .text {
      display: flex;
      flex-direction: column;
      gap: 6px;
    }
  }
`;

export const TagContainer = styled.div<{ recommended: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${(props) => css`
    > .tag {
      font-size: 12px;
      ${() => (isAmazonHost() ? FONT_WEIGHT_NORMAL : FONT_WEIGHT_REGULAR)};
      line-height: 18px;
      background-color: ${() => {
        let color = WHITE;
        if (isAmazonHost()) {
          color = props.recommended ? POSITIVE_500 : NEUTRAL_100;
        }
        return color;
      }};
      color: ${() =>
        isAmazonHost() && props.recommended ? WHITE : NEUTRAL_500};
      ${() =>
        isAmazonHost() && props.recommended ? POSITIVE_500 : NEUTRAL_200};
      padding: 4px 8px;
      border-radius: 4px;
    }
  `}
`;
